<mat-form-field>
  <mat-label>PLZ</mat-label>
  <input
    matInput
    [formControl]="zipControl()"
    [matAutocomplete]="zipAutocomplete"
    autocomplete="nope"
    maxlength="5"
  />
  <mat-error ui-input-errors [control]="zipControl()" />
</mat-form-field>

<mat-autocomplete #zipAutocomplete="matAutocomplete">
  @if (zipResult$ | async; as zipResult) {
    @if (isLoading()) {
      <mat-option>
        <div class="flex justify-between items-center gap-4">
          <mat-spinner color="primary" [diameter]="20" />
          <div>lädt...</div>
        </div>
      </mat-option>
    } @else {
      @if (!zipResult.length) {
        <!-- disabled: a selectable option here would write null over what was typed -->
        <mat-option disabled>keine Auswahl</mat-option>
      }
      @for (item of zipResult; track item) {
        <mat-option (onSelectionChange)="onZipCitySelect(item, $event)" [value]="item.plz">
          {{ item.plz }} {{ item.ort }}
        </mat-option>
      }
    }
  }
</mat-autocomplete>
